<template>
  <div class="po_close_sales_order_open">
    <div style="margin:10px">
      <v-row>
        <v-col cols="12">
          <v-card height="600" elevation="12">
            <v-card-title>
              <v-row>
                <v-col col="6">PO Closed but Sales Order Still Open</v-col>
                <v-col col="6"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedPoClosedSoOpenSearch($event)" style="width:250px;float:right"></v-text-field></v-col>
              </v-row>
            </v-card-title>  
            <v-card-text>
              <Vue3EasyDataTable
                :headers="backorder_po_not_open_in_nest_headers"
                :items="backorders.po_not_open_in_nest"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="450"
                :search-value="searchPoClosedSoOpen"
              >
                <template #item-order_number="item">
                  <span class="dashboard-link" @click="openSalesOrderDetailPopup(item.order_number)">
                    {{item.order_number}}
                  </span>
                  <div v-if="item.white_glove_support_order"
                    style="background: yellow;text-align: center;font-size:8px;line-height:150%;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;margin-bottom:2px">
                    WHITE GLOVE ORDER
                  </div>
                  <div v-if="item.white_glove_tracking_for_this_ship_to"
                    style="background: lightyellow;text-align: center;line-height:150%;font-size:8px;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;">
                    WHITE GLOVE ADDRESS
                  </div>
                </template>

                <template #item-module_po_number="item">
                  <div style="color:#ff7214;cursor:pointer;font-weight:bold"
                    @click="openPurchaseOrderDetailPopup(item.module_po_number)"
                    v-if="item.eta !== 'Linked PO not open in Nest'">
                    {{item.module_po_number}}
                  </div>
                  <div v-if="item.eta == 'Linked PO not open in Nest'">
                    {{item.module_po_number}}
                  </div>
                  <div v-if="item.unlinked_po_number"
                    style="background: pink;text-align: center;font-size:8px; font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;">
                    UNLINKED PO
                  </div>
                </template>

                <template #item-order_date_sortable="item">
                  {{item.order_date_formatted}}
                </template>

                <template #item-eta_sortable="item">
                  {{item.eta_formatted}}
                </template>

                <template #item-po_completed_date_sortable="item">
                  {{item.po_completed_date_formatted}}
                </template>

                <template #item-eta_last_provided_sortable="item">
                  {{item.eta_last_provided_formatted}}
                </template>

              <template #item-so_internal_notes="item">
                <div
                  v-for="n in item.so_internal_notes"
                  style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;width:200px"
                >
                  <div style="font-style:italic">{{ n.note }}</div>
                  <div style="font-size:8px;line-height:100%;color:gray;">
                    submitted {{ formatDate(n.submitted_date) }} n by {{ n.submitted_by_name }}
                  </div>
                </div>
              </template>

              </Vue3EasyDataTable>

            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
  <PurchaseOrderDetailPopUp v-if="po_detail"
    :po="po_for_component"
    @close="closePurchaseOrderDetailPopup()" />

  <SalesOrderDetailPopUp v-if="sales_order_detail"
    :sales_order="sales_order_for_component"
    @close="closeSalesOrderDetailPopup()" />
</template>

<script>
import { mapGetters } from 'vuex'
import Moment from 'moment-business-days'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import XLSX from 'xlsx'
import PurchaseOrderDetailPopUp from '@/components/PurchaseOrderDetailPopUp.vue'
import SalesOrderDetailPopUp from '@/components/SalesOrderDetailPopUp.vue'
import { debounce } from 'lodash';

export default {
  name: 'POClosedSalesOrderOpen',
  components: {
    Vue3EasyDataTable,
    PurchaseOrderDetailPopUp,
    SalesOrderDetailPopUp
  },
  data() {
    return {
      backorder_po_not_open_in_nest_headers: [
        { text: "Customer", value: "customer_name", sortable: true },
        { text: "Sales Order Number", value: "order_number", sortable: true },
        { text: "Sales Order Date", value: "order_date_sortable", sortable: true },
        { text: "Product Number", value: "product_number", sortable: true },
        { text: "PO Number", value: "module_po_number", sortable: true },
        { text: "PO Completed Date", value: "po_completed_date_sortable", sortable: true },
        { text: "Sales Order Internal Notes", value: "so_internal_notes", sortable: false }
      ],
      searchPoClosedSoOpen: '',
      po_detail: false,
      sales_order_detail: false,
      po_for_component: null,
      sales_order_for_component: null,
      table_height: 1500
    }
  },
  beforeMount() {
    if (this.user === 'vendor' || !this.user) {
      this.$router.push('/')
    }
    this.table_height = 1500
  },
  created() {
    window.addEventListener("resize", this.sizeTable)
  },
  destroyed() {
    window.removeEventListener("resize", this.sizeTable)
  },
  computed: {
    ...mapGetters(['user', 'db']),
    backorders() {
      var backorders_db_clone = this.db.backorders
        ? JSON.parse(JSON.stringify(this.db.backorders))
        : {}

      var backorder_modules_data = {
        past_due_missing_etas: [],
        eta_more_than_14_days: [],
        po_not_open_in_nest: [],
        missing_po: [],
        no_mod: []
      }

      for (var b in backorders_db_clone) {
        var backorder = backorders_db_clone[b]
        backorder.eta = 'unknown' // set initially but attempt to find below.
        backorder.id = b
        backorder.so_internal_notes = this.db.sales_orders[backorder.order_number] ? this.db.sales_orders[backorder.order_number].internal_notes : ''
        if (!backorder.completed) {
          if (this.db.purchase_orders[backorder.linked_po_number]) {
            for (var item_key in this.db.purchase_orders[backorder.linked_po_number].items) {
              if (
                this.db.purchase_orders[backorder.linked_po_number].items[item_key].product === backorder.product_number
              ) {
                backorder.eta = this.db.purchase_orders[backorder.linked_po_number].items[item_key].eta
                backorder.eta_last_provided = this.db.purchase_orders[backorder.linked_po_number].items[item_key].eta_last_provided
              }
            }
            if (backorder.eta === 'unknown') {
              backorder.eta = 'Linked PO found but no item match'
            }
          } else {
            if (backorder.linked_po_number) {
              backorder.eta = 'Linked PO not open in Nest'
              backorder.po_not_open_in_nest = true
            }
            if (!backorder.linked_po_number) {
              var potential_purchase_orders = {}
              for (var po in this.db.purchase_orders) {
                if (/[a-zA-Z]/.test(po)) {
                  continue
                }
                for (var item_key in this.db.purchase_orders[po].items) {
                  if (
                    this.db.purchase_orders[po].items[item_key].product === backorder.product_number &&
                    this.db.purchase_orders[po].items[item_key].line_complete === 'N'
                  ) {
                    potential_purchase_orders[po] = {
                      po_date: this.db.purchase_orders[po].po_date,
                      po_date_timestamp: Moment(this.db.purchase_orders[po].po_date)
                        .startOf('day')
                        .valueOf(),
                      eta: this.db.purchase_orders[po].items[item_key].eta,
                      eta_last_provided: this.db.purchase_orders[po].items[item_key].eta_last_provided
                    }
                  }
                }
              }
              if (Object.keys(potential_purchase_orders).length > 0) {
                const oldestPO = Object.keys(potential_purchase_orders).reduce((oldest, key) => {
                  return potential_purchase_orders[key].po_date_timestamp <
                    potential_purchase_orders[oldest].po_date_timestamp
                    ? key
                    : oldest
                }, Object.keys(potential_purchase_orders)[0])
                backorder.unlinked_po_number = oldestPO
                backorder.eta = potential_purchase_orders[oldestPO].eta
                backorder.eta_last_provided = potential_purchase_orders[oldestPO].eta_last_provided
              } else {
                backorder.unlinked_po_number = 'No PO found'
                backorder.eta = 'No PO found'
                backorder.missing_po = true
              }
            }
          }

          backorder.module_po_number = backorder.linked_po_number
            ? backorder.linked_po_number
            : backorder.unlinked_po_number
          backorder.order_date_sortable = Moment(backorder.order_date)
            .startOf('day')
            .valueOf()
          backorder.order_date_formatted = Moment(backorder.order_date).format('MM/DD/YY')
          backorder.eta_is_date = this.isDateString(backorder.eta)

          var eta_string_sorting_options = [
            '',
            'Linked PO found but no item match',
            'Linked PO not open in Nest',
            'No PO found',
            'TBD',
            'UTP'
          ]

          if (backorder.eta_is_date) {
            backorder.eta_sortable = Moment(backorder.eta).startOf('day').valueOf()
            backorder.eta_formatted = backorder.eta
            backorder.past_due = Moment(backorder.eta)
              .startOf('day')
              .valueOf() < Moment().startOf('day').valueOf()
          } else {
            backorder.eta_sortable = eta_string_sorting_options.indexOf(backorder.eta)
            backorder.eta_formatted = backorder.eta
          }

          if (backorder.eta_last_provided) {
            backorder.eta_last_provided_sortable = backorder.eta_last_provided
            backorder.eta_last_provided_formatted = Moment(backorder.eta_last_provided).format('MM/DD/YY')
          } else {
            backorder.eta_last_provided_sortable = 0
            backorder.eta_last_provided_formatted = ''
          }

          if (
            (!backorder.eta_is_date && !backorder.missing_po && !backorder.po_not_open_in_nest) ||
            backorder.past_due
          ) {
            backorder_modules_data.past_due_missing_etas.push(backorder)
            backorder.in_mod = true
          }

          if (backorder.po_not_open_in_nest) {
            backorder_modules_data.po_not_open_in_nest.push(backorder)
            backorder.in_mod = true
          }

          if (backorder.missing_po) {
            var fiveDaysAgoFromNow = Moment()
              .subtract(5, 'days')
              .startOf('day')
              .valueOf()
            if (backorder.order_date_sortable < fiveDaysAgoFromNow) {
              backorder.older_than_five_days = true
            }
            backorder_modules_data.missing_po.push(backorder)
            backorder.in_mod = true
          }

          if (backorder.eta_is_date) {
            var fourteenDaysFromNow = Moment().add(14, 'days').startOf('day').valueOf()
            if (backorder.eta_sortable > fourteenDaysFromNow) {
              backorder_modules_data.eta_more_than_14_days.push(backorder)
              backorder.in_mod = true
            }
          }

          if (!backorder.in_mod) {
            backorder_modules_data.no_mod.push(backorder)
          }
          backorder.po_completed_date_sortable = this.db.recently_completed_purchase_orders[backorder.module_po_number] ? this.db.recently_completed_purchase_orders[backorder.module_po_number].po_complete_date : false
          backorder.po_completed_date_formatted = backorder.po_completed_date_sortable ? this.formatDate(backorder.po_completed_date_sortable) : 'PO Closed > 1 Week'
        }
      }
      return backorder_modules_data
    }
  },
  methods: {
    debouncedPoClosedSoOpenSearch: debounce(function(event) {
      this.searchPoClosedSoOpen = event.target._value.replace(/\*/g, "");
    }, 500),    
    openPurchaseOrderDetailPopup(po) {
      this.po_for_component = po
      this.po_detail = true
    },
    closePurchaseOrderDetailPopup() {
      this.po_for_component = null
      this.po_detail = false
    },
    openSalesOrderDetailPopup(sales_order) {
      this.sales_order_for_component = sales_order
      this.sales_order_detail = true
    },
    closeSalesOrderDetailPopup() {
      this.sales_order_for_component = null
      this.sales_order_detail = false
    },
    isDateString(str) {
      if (typeof str !== 'string') return false
      return (str.match(/\//g) || []).length === 2
    },
    sizeTable() {
      var wh = window.innerHeight
      this.table_height = wh - 50
    },
    formatDate(date) {
      return Moment(date).format('MM/DD/YY')
    }
  }
}
</script>

<style scoped>
  .v-card .v-card-title {
    color: gray;
    font-size: 14px;
  }

  .v-card .v-card-text {
    line-height: 100%;
  }

  .table-container {
    position: relative;
    top: 5px;
    margin: 0px 20px;
  }

  .flagged {
    width: 20px;
    height: 20px;
    border: 1px solid #ff7214;
    background: #ff7214;
    cursor: pointer;
  }

  .unflagged {
    width: 20px;
    height: 20px;
    border: 1px solid #ff7214;
    cursor: pointer;
  }

  .needs_attention {
    background: red;
    color: white;
    width: 15px;
    height: 15px;
    text-align: center;
    font-size: 12px;
    line-height: 140%;
    font-weight: bold;
    border-radius: 100%;
  }

  a {
    text-decoration: none;
  }

  .v-card-actions {
    min-height: 0px;
    padding: 4px 0px;
  }

  .dashboard-link {
    color: #ff7214;
    cursor: pointer;
    font-weight: bold;
    font-size: 11px;
  }
</style>
